<app-help-page mainVideo="exports"
               [tutorials]="['exports', 'quick-start']"
               [videos]="['exports', 'export-destinations']"></app-help-page>
